"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var swagger_exports = {};
__export(swagger_exports, {
  OpenApiNetworkBlocked: () => OpenApiNetworkBlocked,
  blockedSwaggerUiActions: () => blockedSwaggerUiActions,
  blockedSwaggerUiFunctions: () => blockedSwaggerUiFunctions,
  buildSwaggerUiConfig: () => buildSwaggerUiConfig,
  removeSwaggerUiControls: () => removeSwaggerUiControls,
  removedSwaggerUiComponents: () => removedSwaggerUiComponents,
  swaggerUiControlSelectors: () => swaggerUiControlSelectors,
  swaggerUiLockdownPlugin: () => swaggerUiLockdownPlugin
});
module.exports = __toCommonJS(swagger_exports);
const removedSwaggerUiComponents = [
  // Authorisation.
  "authorizeBtn",
  "AuthorizeBtn",
  "authorizeOperationBtn",
  "AuthorizeOperationBtn",
  "authorizationPopup",
  "AuthorizationPopup",
  "auths",
  "Auths",
  "apiKeyAuth",
  "ApiKeyAuth",
  "basicAuth",
  "BasicAuth",
  "oauth2",
  "Oauth2",
  "AuthorizationSelector",
  // Calling the API.
  "TryItOutButton",
  "tryItOutButton",
  "Execute",
  "execute",
  "ExecuteWrapper",
  "Curl",
  "curl",
  "LiveResponse",
  "liveResponse",
  "RequestBodyEditor",
  "requestBodyEditor",
  // Chrome that would talk to somebody: the online validator badge, and the standalone
  // layout's "explore" bar, which loads whatever address is typed into it.
  "onlineValidatorBadge",
  "OnlineValidatorBadge",
  "ValidatorImage",
  "Topbar",
  "topbar",
  "StandaloneLayout"
];
const blockedSwaggerUiActions = {
  spec: ["download", "execute", "executeRequest"],
  auth: [
    "authorize",
    "authorizeWithPersistOption",
    "authorizeOauth2",
    "authorizeOauth2WithPersistOption",
    "authorizeRequest",
    "authorizeAccessCodeWithFormParams",
    "authorizeAccessCodeWithBasicAuthentication",
    "authorizePassword",
    "authorizeApplication",
    "preAuthorizeImplicit",
    "persistAuthorizationIfNeeded",
    "logout"
  ]
};
const blockedSwaggerUiFunctions = ["fetch", "execute", "http"];
const swaggerUiControlSelectors = [
  ".auth-wrapper",
  ".auth-container",
  ".authorization__btn",
  "button.authorize",
  ".btn.authorize",
  ".try-out",
  ".try-out__btn",
  ".btn.execute",
  ".execute-wrapper",
  ".download-url-wrapper",
  ".topbar",
  ".information-container .info__validator",
  ".validation-errors"
];
function removeSwaggerUiControls(root) {
  let removed = 0;
  for (const selector of swaggerUiControlSelectors) {
    const found = root.querySelectorAll(selector);
    for (let i = 0; i < found.length; i++) {
      found[i].remove();
      removed++;
    }
  }
  return removed;
}
__name(removeSwaggerUiControls, "removeSwaggerUiControls");
class OpenApiNetworkBlocked extends Error {
  static {
    __name(this, "OpenApiNetworkBlocked");
  }
  constructor(what) {
    super(`An OpenAPI block does not call the API it documents (${what} was blocked).`);
    this.name = "OpenApiNetworkBlocked";
  }
}
function blocked(what) {
  return () => {
    throw new OpenApiNetworkBlocked(what);
  };
}
__name(blocked, "blocked");
function swaggerUiLockdownPlugin() {
  const components = {};
  for (const name of removedSwaggerUiComponents) {
    components[name] = () => null;
  }
  const fn = {};
  for (const name of blockedSwaggerUiFunctions) {
    fn[name] = blocked(`fn.${name}`);
  }
  const statePlugins = {};
  for (const [plugin, actions] of Object.entries(blockedSwaggerUiActions)) {
    const blockedActions = {};
    for (const action of actions) {
      blockedActions[action] = blocked(`${plugin}.${action}`);
    }
    statePlugins[plugin] = { actions: blockedActions };
  }
  return { components, fn, statePlugins };
}
__name(swaggerUiLockdownPlugin, "swaggerUiLockdownPlugin");
function buildSwaggerUiConfig(spec) {
  return {
    // The document itself, so nothing is resolved over the network. There is deliberately no
    // `url`, no `urls` and no `configUrl` field on this object at all.
    spec,
    supportedSubmitMethods: [],
    tryItOutEnabled: false,
    validatorUrl: null,
    deepLinking: false,
    queryConfigEnabled: false,
    persistAuthorization: false,
    withCredentials: false,
    showMutatedRequest: false,
    displayRequestDuration: false,
    layout: "BaseLayout",
    docExpansion: "list",
    defaultModelsExpandDepth: 1,
    defaultModelExpandDepth: 2,
    defaultModelRendering: "example",
    requestInterceptor: blocked("a request"),
    responseInterceptor: blocked("a response"),
    plugins: [swaggerUiLockdownPlugin()]
  };
}
__name(buildSwaggerUiConfig, "buildSwaggerUiConfig");
//# sourceMappingURL=swagger.js.map
